import { Link } from "react-router-dom";

const catLinks = ["热血", "奇幻", "科幻", "恋爱", "悬疑", "古风", "日常"];
const aboutLinks = ["关于我们", "番剧列表", "在线观看", "资源下载"];

export default function Footer() {
  return (
    <footer className="mt-auto bg-gradient-to-b from-background-900 to-[#24130c] text-foreground-200">
      <div className="container-site grid gap-10 py-12 md:grid-cols-4 md:py-16">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-950">
              <i className="ri-movie-2-line text-lg" />
            </span>
            <span className="font-heading text-xl text-foreground-50">
              奶水动漫<span className="text-primary-400">.</span>
            </span>
          </Link>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-400">
            奶水动漫是一个专注二次元漫迷的动画资源站，提供热门动画免费在线观看、全集收录与高清下载。无需繁琐步骤，点开即可追更，资源持续整理更新。
          </p>
          <div className="mt-5 flex gap-3">
            {["ri-weibo-line", "ri-bilibili-line", "ri-discord-line", "ri-telegram-line"].map((ic) => (
              <a
                key={ic}
                href="#"
                rel="nofollow"
                aria-label="社交平台"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-background-700 text-foreground-300 transition-colors hover:border-primary-500 hover:text-primary-400"
              >
                <i className={`${ic} text-lg`} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-bold text-foreground-100">番剧分类</h4>
          <ul className="grid grid-cols-2 gap-2">
            {catLinks.map((c) => (
              <li key={c}>
                <Link to={`/list?cat=${encodeURIComponent(c)}`} className="text-sm text-foreground-400 transition-colors hover:text-primary-400">
                  {c}番剧
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-bold text-foreground-100">快速入口</h4>
          <ul className="space-y-2">
            {aboutLinks.map((a) => (
              <li key={a}>
                <Link to={a === "关于我们" ? "/about" : "/list"} className="text-sm text-foreground-400 transition-colors hover:text-primary-400">
                  {a}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/about" className="text-sm text-foreground-400 transition-colors hover:text-primary-400">
                联系方式
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-800/70">
        <div className="container-site flex flex-col items-center justify-between gap-2 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} 奶水动漫 nsshipin.site · 仅供个人学习交流使用</p>
          <p>陪你追更 · 一网打尽优质动画资源</p>
        </div>
      </div>
    </footer>
  );
}